import React, { useEffect, useState } from 'react';
import { dataExportsAPI } from '../../../api';

const FrequencySelector = ({frequency, setFrequency, customStyles}) => {

  const [nextForwardingTimes, setNextForwardingTimes] = useState({});

  const fetchNextForwardingTimes = async () => {
    try {
      let response = await dataExportsAPI.get('/cloud-delivery-settings/next-forwarding-times');
      let data = response.data.data;
      setNextForwardingTimes({
        daily: new Date(data.nextDaily).toLocaleString(),
        weekly: new Date(data.nextWeekly).toLocaleString()
      });
    } catch (error) {
      console.error('Error fetching next forwarding times:', error);
    }
  };

  useEffect(() => {
    fetchNextForwardingTimes();
  }, []);

  const handleButtonClick = (value) => {
    setFrequency(value);
  };

  return (
    <div className="setting-form-config-section">
      <h3>Frequency</h3>
      <div className="setting-form-frequency-buttons">
        {['Daily', 'Weekly'].map(freq => (
          <button 
            key={freq} 
            className={`setting-form-freq-btn ${frequency.includes(freq.toLowerCase()) ? 'active' : ''}`}
            onClick={() => handleButtonClick(freq.toLowerCase())}
          >
            {freq}
          </button>
        ))}
      </div>
      {nextForwardingTimes.daily || nextForwardingTimes.weekly ? (
        <div className="setting-form-selected-frequencies">
          Selected: {frequency.length ? frequency : 'None'}
          <br />
          Next Forwarding Time: {frequency === 'daily' ? nextForwardingTimes.daily : nextForwardingTimes.weekly || 'N/A'}
        </div>
      ) : null}
    </div>
  );
};

export default FrequencySelector;
